import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfessionalScheduleService {
  constructor(private http: HttpClient) {}
  
  getAll() {
    return this.http
      .get('https://api-fake-r9p5.onrender.com/professional-schedules') as Observable<any[]>;
      //.pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessional[]>;
  }

  save(req: any) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/professional-schedules',
      req
    ) as Observable<any>;
  }

  
  edit(req: any, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `https://api-fake-r9p5.onrender.com/professional-schedules/${id}`,
      req,
      { headers: headers }
    ) as Observable<any>;
  }

  delete(id: number) {
    return this.http.delete(
      `https://api-fake-r9p5.onrender.com/professional-schedules/${id}`
    ) as Observable<any>;
  }
}
